// Centralized helpers for displaying metric data
export function formatHashrate(mhs) {
  if (!mhs && mhs !== 0) return "—";
  const n = Number(mhs);
  if (n >= 1000) return `${(n / 1000).toFixed(2)} GH/s`;
  if (n >= 1) return `${n.toFixed(2)} MH/s`;
  if (n > 0) return `${(n * 1000).toFixed(2)} kH/s`;
  return "0.00 MH/s";
}

export function formatPower(w) {
  if (!w && w !== 0) return "—";
  const n = Number(w);
  if (n >= 1000) return `${(n / 1000).toFixed(2)} kW`;
  return `${n.toFixed(0)} W`;
}

export function formatUptime(seconds) {
  if (!seconds) return "—";
  const s = Number(seconds);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}

export function efficiency(hashrate, power) {
  if (!power || power <= 0) return "—";
  return `${(hashrate / power).toFixed(3)} MH/W`;
}

export function tempColor(t) {
  if (t >= 82) return "text-[#EF4444]";
  if (t >= 75) return "text-[#F59E0B]";
  if (t >= 65) return "text-[#FACC15]";
  return "text-[#10B981]";
}

export function timeAgo(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return `${Math.floor(diff)}s fa`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m fa`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h fa`;
  return `${Math.floor(diff / 86400)}g fa`;
}
